import React, { useState } from "react";
import { connect } from "react-redux";
import { setUploadFiles, setCustomerAttachmentId } from "../../actions/action";
import fetchApiData from "../apiHandlers/fetchApiData";
import Dropzone from "react-dropzone";
import CONSTANTS from "../../constants";
import acDocumentIcon from "../../images/AC/ac_document_file.png";

const mapStateToProps = (state) => state;
const mapDispatchToProps = { setUploadFiles, setCustomerAttachmentId };

const AttachmentsFlex = (props) => {
  const [showFormErrors, setShowFormErrors] = useState(false);
  const [ErrorMsg, setErrorMsg] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const validateAttachmentFile = (file) => {
    let fileList = props.store.UploadFiles;
    let attachmentId = props.store.customerAttachmentId;
    const fileService = new fetchApiData();
    const formData = new FormData();

    formData.append("file", file);
    fileService.postSendFile(formData).then(
      (res) => {
        console.log("validate file", res)
        switch (res.errorCode) {
          case 0:
            file.attachmentUrl = res.encodedUrl;
            fileList.push(file);
            props.setUploadFiles(fileList);
            if (attachmentId === "") {
              props.setCustomerAttachmentId(res.customerAttachmentId);
            }
            setIsLoading(false);
            setShowFormErrors(false);
            break;

          default:
            setIsLoading(false);
            setShowFormErrors(true);
            setErrorMsg(res.message);
            break;
        }
      },
      (error) => {
        console.log(error);
        setIsLoading(false);
        setShowFormErrors(true);
        setErrorMsg(error.message);
      }
    );
  };

  const removeFile = (file) => {
    let fileList = props.store.UploadFiles;
    //New traitement for removing file just from front
    const newFiles = [...fileList]; // make a var for the new array
          newFiles.splice(newFiles.indexOf(file), 1); // remove the file from the array
          props.setUploadFiles(newFiles);
    /*const removeFileService = new fetchApiData();
    removeFileService.DeleteAttachment(file.attachmentUrl).then(
      (res) => {
        if (res.d.status === "OK") {
          const newFiles = [...fileList]; // make a var for the new array
          newFiles.splice(newFiles.indexOf(file), 1); // remove the file from the array
          props.setUploadFiles(newFiles);
        }
      },
      (error) => {
        setIsLoading(false);
        setShowFormErrors(true);
        setErrorMsg(error.message);
      }
    );*/
  };

  return (
    <React.Fragment>
      <div className={`form-wrapper ${props.classes}`}>
        <Dropzone
          onDrop={(acceptedFiles) => {
            if (acceptedFiles.length > 3) {
              setShowFormErrors(true);
              setErrorMsg("Un client ne peut uploader que 3 pièces jointes max.");
            } else {
              acceptedFiles.forEach((file) => {
                setShowFormErrors(false);
                const reader = new FileReader();

                reader.onabort = () => {
                  console.log("file reading was aborted");
                };
                reader.onerror = () => {
                  console.log("file reading has failed");
                };
                reader.onload = () => {
                  console.log("file loading ...");
                  setIsLoading(true);
                  validateAttachmentFile(file);
                };
                reader.readAsArrayBuffer(file);
              });
            }
          }}
        >
          {({ getRootProps, getInputProps }) => (
            <React.Fragment>
              {window.siteConfig.currentBrand !== 'C' && 
              <React.Fragment>
                {props.store.UploadFiles.length > 0 && (
                  <div className="filesUploadedContainer">
                    {Object.values(props.store.UploadFiles).map((file, key) => {
                      return (
                        <div className="iconFileContainer">
                          <div className="iconFileSubContainer">
                            <img src={acDocumentIcon} />
                            <div key={key} className="fileTitle">
                              {file.path}
                            </div>
                          </div>
                          <i
                            tabIndex="0"
                            onKeyDown={(e) =>
                              e.key === "Enter" && removeFile(file)
                            }
                            onClick={() => removeFile(file)}
                            className="mark-icons delete-icon deleteFileIcon"
                          />
                        </div>
                      );
                    })}
                  </div>
                )}
              </React.Fragment>
              }
              <div {...getRootProps()} className="attachmentBody">
                <input {...getInputProps()} />
                <label className="attachmentButton">
                  {CONSTANTS.LABELS.needs_attachment_cta2}
                </label>
                <div className="attachmentSubtitle">
                  {`${CONSTANTS.LABELS.needs_attachment_cta1} ${CONSTANTS.LABELS.needs_attachment_cta2}`}
                </div>
               </div> 
              {window.siteConfig.currentBrand === 'C' && 
                <React.Fragment>
                {props.store.UploadFiles.length > 0 && (
                  <div className="filesUploadedContainer">
                    {Object.values(props.store.UploadFiles).map((file, key) => {
                      return (
                        <div className="iconFileContainer">
                          <div className="iconFileSubContainer">
                            <img src={acDocumentIcon} />
                            <div key={key} className="fileTitle">
                              {file.path}
                            </div>
                          </div>
                          <i
                            tabIndex="0"
                            onKeyDown={(e) =>
                              e.key === "Enter" && removeFile(file)
                            }
                            onClick={() => removeFile(file)}
                            className="mark-icons delete-icon deleteFileIcon"
                          />
                        </div>
                      );
                    })}
                  </div>
                )}
                </React.Fragment>
              }
             
            </React.Fragment>
          )}
        </Dropzone>
      </div>
      {showFormErrors && (
        <div className="section-form">
          <span className="input-errorLabel">{ErrorMsg}</span>
        </div>
      )}
    </React.Fragment>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(AttachmentsFlex);
